module.exports = __webpack_public_path__ + "media/images/bg-b49207d16ea2f09c2c1c5a7e6992be6e.jpeg";